import {
  Backdrop,
  Checkbox,
  Chip,
  CircularProgress,
  Icon,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import moment from "moment";
import { Enumerations } from "../../config/Enumerations";
import { getEntryStatusColor } from "../common/VisualElementsHelper";
import { useNavigate } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { AppReviewRepository } from "../repositories/AppReviewRepository";
import { useEffect, useState } from "react";
import { AuthRepository } from "../repositories/AuthRepository";
import Avatar from "@mui/material/Avatar";
import {
  notifyShowErrorMessage,
  notifyShowSuccessMessage,
} from "../../store/AlertSlice";
import { useDispatch } from "react-redux";
import { CheckCircle } from "@mui/icons-material";

export default function ReviewTable({
  loading,
  data,
  handleChangePage,
  handleChangeRowsPerPage,
  getAll,
  showArchivedColumn,
  forAssignment,
}) {
  const [saving, setSaving] = useState(false);
  const [hasArchivePermission, setHasArchivePermission] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const dispatch = useDispatch();

  useEffect(() => {
    setHasArchivePermission(
      AuthRepository.hasAnyRole(["ROLE_JPDP_RECEIVER", "ROLE_MVR_RECEIVER"]) &&
        getAll !== undefined,
    );
  }, []);

  const markOutputDocumentAsArchived = (appReviewId, checked) => {
    AppReviewRepository.markOutputDocumentAsArchived(appReviewId, checked)
      .then(() => {
        dispatch(
          notifyShowSuccessMessage(
            checked
              ? "Успешно го означивте излезениот документ како архивиран."
              : "Успешно го отстранивте означувањето на излезениот документ како архивиран.",
          ),
        );
        if (getAll) {
          getAll(0, 10, {}, "id", "DESC");
        }
      })
      .catch((err) => {
        console.error("Error marking document as archived:", err);
      });
  };

  function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  function stringAvatar(name) {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
    };
  }

  return (
    <>
      <Table size="small" style={{ marginTop: "20px" }}>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography
                variant="subtitle1"
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "13px",
                  lineHeight: "1.1",
                }}
              >
                Број на запис
              </Typography>
            </TableCell>
            {showArchivedColumn && (
              <TableCell style={{ textAlign: "center" }}>
                <Typography
                  variant="subtitle1"
                  style={{
                    fontFamily: "Inter-Medium",
                    fontSize: "12px",
                    lineHeight: "1.1",
                    color: "#333",
                  }}
                >
                  Архивски број
                  <br />
                  (Од Институција)
                </Typography>
              </TableCell>
            )}
            <TableCell>
              <Typography
                variant="subtitle1"
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "12px",
                  lineHeight: "1.1",
                  color: "#333",
                }}
              >
                Подносител/Проектантско биро/Барање
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="subtitle1"
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "12px",
                  lineHeight: "1.1",
                  color: "#333",
                }}
              >
                Време на поднесување
                <br />
                (Од МТ до Институција)
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="subtitle1"
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "12px",
                  lineHeight: "1.1",
                  color: "#333",
                }}
              >
                Статус
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="subtitle1"
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "12px",
                  lineHeight: "1.1",
                  color: "#333",
                }}
              >
                Датум на одлука
                <br />
                (Испратено до МТ)
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="subtitle1"
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "12px",
                  lineHeight: "1.1",
                  color: "#333",
                }}
              >
                Тех. број
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="subtitle1"
                style={{
                  fontFamily: "Inter-Medium",
                  fontSize: "12px",
                  lineHeight: "1.1",
                  color: "#333",
                }}
              >
                Тип на барање
              </Typography>
            </TableCell>
            {hasArchivePermission && (
              <TableCell style={{ textAlign: "center" }}>
                <Typography
                  variant="subtitle1"
                  style={{
                    fontFamily: "Inter-Medium",
                    fontSize: "12px",
                    lineHeight: "1.1",
                    color: "#333",
                  }}
                >
                  Архивиран
                </Typography>
              </TableCell>
            )}
            <TableCell></TableCell>
            <TableCell>Доделен</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        {loading && (
          <TableBody>
            <TableRow>
              <TableCell colSpan={12} align="center" style={{ padding: "40px" }}>
                <CircularProgress />
              </TableCell>
            </TableRow>
          </TableBody>
        )}

        {!loading && data?.content?.length === 0 && (
          <TableBody>
            <TableRow>
              <TableCell colSpan={12} align="center" style={{ padding: "5px" }}>
                <Typography
                  variant="body2"
                  style={{
                    fontFamily: "Inter-Regular",
                    fontSize: "12px",
                    lineHeight: "1.1",
                  }}
                >
                  <i>Нема податоци</i>
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        )}

        {!loading && (
          <>
            <TableBody>
              {data?.content?.map((entry, index) => (
                <TableRow
                  key={index}
                  sx={{
                    cursor: "pointer",
                    backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
                    borderLeft: `5px solid ${getEntryStatusColor(entry.status)}`,
                    "&:hover": {
                      backgroundColor: "#ededed",
                    },
                  }}
                  onClick={() => {
                    forAssignment
                      ? navigate(`/reviews/assignment/${entry?.id}`)
                      : navigate(`/reviews/details/${entry?.id}`);
                  }}
                >
                  <TableCell sx={{ py: 1 }}>
                    {entry?.appEntry?.entryNumber}
                  </TableCell>
                  {showArchivedColumn && (
                    <TableCell style={{ textAlign: "center" }}>
                      {entry?.instArchiveNumber ?? "- НЕМА -"}
                    </TableCell>
                  )}
                  <TableCell sx={{ py: 1 }}>
                    {entry?.appEntry?.appEntryData?.applicantName}/
                    {entry?.appEntry?.appEntryData?.projectBureauName}/
                    {entry?.appEntry?.appEntryData?.subject}
                  </TableCell>
                  <TableCell sx={{ py: 1 }}>
                    {entry?.createdAt
                      ? moment(entry?.createdAt).format("DD.MM.YYYY HH:mm")
                      : "-"}
                  </TableCell>
                  <TableCell sx={{ py: 1 }}>
                    <Chip
                      label={
                        Enumerations.AppReviewStatus[entry?.reviewStatus] ||
                        entry?.reviewStatus
                      }
                      sx={{
                        backgroundColor: getEntryStatusColor(
                          entry?.reviewStatus,
                        ),
                        color: "#fff",
                        fontSize: "12px",
                        fontFamily: "Inter-Regular",
                      }}
                    />
                  </TableCell>
                  <TableCell sx={{ py: 1 }}>
                    {entry?.dateOfDecision
                      ? moment(entry?.dateOfDecision).format("DD.MM.YYYY HH:mm")
                      : "-"}
                  </TableCell>
                  <TableCell sx={{ py: 1 }}>
                    {entry?.appEntry?.appEntryData?.projectTechnicalNumber}
                  </TableCell>
                  <TableCell sx={{ py: 1 }}>
                    {Enumerations.AppEntryTypeDisplay[entry?.appEntry?.type] ||
                      entry?.type}
                  </TableCell>
                  <TableCell sx={{ py: 1 }} style={{ textAlign: "center" }}>
                    {hasArchivePermission && (
                      <>
                        {entry?.isArchivedOutputDoc ? (
                          <Checkbox
                            color="success"
                            checked={true}
                            size="small"
                            onClick={(e) => {
                              markOutputDocumentAsArchived(entry?.id, false);
                              e.stopPropagation();
                            }}
                          />
                        ) : (
                          <Checkbox
                            color="error"
                            style={{ zIndex: 100 }}
                            checked={false}
                            size="small"
                            onClick={(e) => {
                              markOutputDocumentAsArchived(entry?.id, true);
                              e.stopPropagation();
                            }}
                          />
                        )}
                      </>
                    )}
                  </TableCell>
                  <TableCell>
                    {entry?.assignedTo && (
                      <Avatar
                        {...stringAvatar(
                          `${entry?.assignedTo?.firstName} ${entry?.assignedTo?.lastName}`,
                        )}
                      />
                    )}
                  </TableCell>
                  <TableCell>
                    <IconButton style={{ padding: 0 }}>
                      <IoIosArrowForward
                        size={16}
                        color={theme.palette.primary.main}
                        style={{ padding: 0 }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter
              style={{
                position: "sticky",
                bottom: 0,
                zIndex: 1,
                background: "white",
              }}
            >
              <TableRow>
                <TablePagination
                  style={{ borderBottom: "none" }}
                  rowsPerPageOptions={[5, 10, 25]}
                  colSpan={12}
                  count={data?.totalElements ?? 0}
                  rowsPerPage={data?.size ?? 10}
                  page={data?.number ?? 0}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </>
        )}
      </Table>

      {saving && (
        <Backdrop open={true} sx={{ zIndex: 9999, color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </>
  );
}
